import { render, staticRenderFns } from "./QuestionHeading.vue?vue&type=template&id=8bc9f170&scoped=true&"
import script from "./QuestionHeading.vue?vue&type=script&lang=js&"
export * from "./QuestionHeading.vue?vue&type=script&lang=js&"
import style0 from "./QuestionHeading.vue?vue&type=style&index=0&id=8bc9f170&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc9f170",
  null
  
)

export default component.exports